import styled from 'styled-components';

export const Container = styled.div`
  pointer-events: auto;
  /* height: 66.66vh;
  pointer-events: none; */
`;
